/**
 * A real document load, not an in-app retry.
 *
 * The default recovery action for a surface that cannot trust the running app —
 * a crash boundary re-rendering the tree that just threw would only throw
 * again. A caller with something cheaper and safer (re-running loaders, say)
 * passes its own handler instead.
 */
export function reloadPage() {
  window.location.reload();
}
